module.exports = __webpack_public_path__ + "static/media/note-3_5.1137ed0d.png";